import React, { Fragment, PureComponent } from "react";
import { UISref } from "@uirouter/react";
import _ from "lodash";
import PropTypes from "prop-types";
import i18n from "i18next";

import { SearchResultsTypes } from "../SearchResultsTypes";
import ResultsHighlighter from "./ResultsHighlighter";

class MillOrdersTile extends PureComponent {
  static propTypes = {
    onShowAllMillOrder: PropTypes.func.isRequired,
    itemsWithAllMillOrderShown: PropTypes.array,
    millOrdersShown: PropTypes.number,
    result: PropTypes.object,
    searchField: PropTypes.string,
    searchQuery: PropTypes.string
  };

  static defaultProps = {
    itemsWithAllMillOrderShown: [],
    millOrdersShown: 3,
    result: {},
    searchField: "",
    searchQuery: ""
  };

  get shouldShowAllMillOrders() {
    return this.props.itemsWithAllMillOrderShown.includes(this.props.result.id);
  }

  get sortedMillOrders() {
    const { millOrders = [] } = this.props.result;

    return _.sortBy(millOrders, millOrder => {
      const { millOrderId = "" } = millOrder;
      return millOrderId.toLowerCase().includes(this.props.searchQuery.toLowerCase()) ? 0 : 1;
    });
  }

  get filteredMillOrders() {
    return !this.shouldShowAllMillOrders ? _.slice(this.sortedMillOrders, 0, this.props.millOrdersShown) : this.sortedMillOrders;
  }

  handleShowAllMillOrders = () => this.props.onShowAllMillOrder(this.props.result.id);

  render() {
    const isMillOrdersEmpty = _.isEmpty(this.props.result.millOrders);

    return (
      <div className="advanced-search__tile">
        {isMillOrdersEmpty && <div className="advanced-search__list-row --no-result">{i18n.t("advancedSearch.noMillOrders")}</div>}

        {!isMillOrdersEmpty && (
          <Fragment>
            <div className="advanced-search__list-row">
              <span className="advanced-search__label --flex-3">{i18n.t("advancedSearch.millOrder")}</span>
            </div>

            <div className="advanced-search__list-container --mill-orders">
              {this.filteredMillOrders.map(millOrder => {
                const { id, millOrderId } = millOrder;

                return (
                  <div className="advanced-search__list-row --value" key={id}>
                    <UISref to="OrderPage" params={{ customerPOId: this.props.result.id, breadcrumbStack: ["OrderPage"] }}>
                      <span className="advanced-search__value --link --flex-3">
                        <ResultsHighlighter
                          className="advanced-search__highlight"
                          searchField={this.props.searchField}
                          searchQuery={this.props.searchQuery}
                          fieldName={SearchResultsTypes.millOrder}
                          textToHighlight={millOrderId}
                        />
                      </span>
                    </UISref>
                  </div>
                );
              })}
            </div>

            <div className="advanced-search__list-row --button">
              {!this.shouldShowAllMillOrders &&
                this.sortedMillOrders.length > this.props.millOrdersShown && (
                  <button className="advanced-search__button --alternate --small" onClick={this.handleShowAllMillOrders}>
                    {i18n.t("advancedSearch.allMillOrders")}
                  </button>
                )}
            </div>
          </Fragment>
        )}
      </div>
    );
  }
}
export default MillOrdersTile;



// WEBPACK FOOTER //
// ./src/components/AdvancedSearch/SearchResults/Tiles/MillOrdersTile.js